import React from "react"
//import I18n from "i18n-js/index.js.erb"
import clsx from 'clsx'
import DateHelper from "../../DateHelper/DateHelper"
import FolioBuilderItemSummaryRow from "./FolioBuilderItemSummaryRow"
import FolioBuilderPaymentSummaryRow from "./FolioBuilderPaymentSummaryRow"

class FolioBuilderSummary extends React.Component {
  constructor(props) {
    super(props)
    this.formatCurrency = this.formatCurrency.bind(this)
  }

  render() {

    var self = this;
    var dateFormat = DateHelper.rubyToDateJS(this.props.date_format);


    var tabClasses = clsx({
      'active': this.props.active_tab == 'summary',
      'tab-pane': true
    });

    return(
      <div className={tabClasses} id="summary">
        {
          this.props.summary
          ?

          <div className="panel panel-default">
            <div className="panel-heading">
              <div className="panel-title">{I18n.t("folio")}</div>
            </div>
            <div className="panel-body">

              <label>{I18n.t('summary')}</label>

              <table className="table table-bordered">
                {this.renderSummaryTableHead()}
                {this.renderSummaryTableBody()}
              </table>

              <br />
              <br />

              <label>{I18n.t('charges')}</label>

              <table className="table table-bordered">
                {this.renderItemTableHead()}
                {this.renderItemTableBody()}
              </table>

              <br />
              <br />

              <label>{I18n.t('payments')}</label>

              <table className="table table-bordered">
                {this.renderPaymentTableHead()}
                {this.renderPaymentTableBody()}
              </table>


            </div>
          </div>
          :
          null
        }
      </div>
    )
  }

  renderSummaryTableHead() {
    return(
      <thead className="thead">
        <tr className="active">
          <th scope="col">{I18n.t("total_charges")}</th>
          <th scope="col">{I18n.t("payments")}</th>
          {/* <th scope="col">{I18n.t('refunds')}</th> */}
          <th scope="col">{I18n.t('authorized')}</th>
          <th scope="col">{I18n.t('balance')}</th>
        </tr>
      </thead>
    )
  }

  renderSummaryTableBody() {
    return (
      <tbody>
        <tr>
          <td>{this.formatCurrency(this.props.summary.total)}</td>
          <td>{this.formatCurrency(this.props.summary.total_paid)}</td>
          <td>{this.formatCurrency(0)}</td>
          <td>{this.formatCurrency(this.props.summary.balance)}</td>
        </tr>
      </tbody>
    )
  }

  renderItemTableHead() {
    return(
      <thead className="thead">
        <tr className="active">
          <th scope="col">{I18n.t("item_date")}</th>
          <th scope="col">{I18n.t("description")}</th>
          <th scope="col">{I18n.t('taxes')}</th>
          <th scope="col">{I18n.t('discount')}</th>
          <th scope="col">{I18n.t("total_amount")}</th>
        </tr>
      </thead>
    )
  }

  renderItemTableBody() {
    var self = this;
    var items = this.props.summary.items
    var payments = this.props.summary.payments

    var item_rows = items.map(function(item) {
      return <FolioBuilderItemSummaryRow key={item.id} item={item} date_format={self.props.date_format} formatCurrency={self.formatCurrency} />
    })

    return(
      <tbody>
        {item_rows}
      </tbody>
    )
  }


  renderPaymentTableHead() {
    return(
      <thead className="thead">
        <tr className="active">
          <th scope="col">{I18n.t("processed_at")}</th>
          <th scope="col">{I18n.t("description")}</th>
          <th scope="col">{I18n.t("amount")}</th>
        </tr>
      </thead>
    )
  }

  renderPaymentTableBody() {
    var self = this;
    var payments = this.props.summary.payments

    var payment_rows = payments.map(function(payment) {
      return <FolioBuilderPaymentSummaryRow key={payment.id} payment={payment} date_format={self.props.date_format} formatCurrency={self.formatCurrency} />
    })

    return(
      <tbody>
        {payment_rows}
      </tbody>
    )
  }

  formatCurrency(num) {
      return I18n.t('number.currency.format.unit') + numeral(num / 100).format('0' + I18n.t('number.currency.format.delimiter') + '0.00');
  }
}

export default FolioBuilderSummary